"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTooltip = exports.StyledMessage = exports.Label = exports.ControlWrapper = exports.Wrapper = exports.Checkbox = exports.IconCheck = exports.NativeCheckbox = exports.StyledCheckboxTooltip = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const tooltip_1 = require("@pulse-web-ui/tooltip");
const react_1 = require("react");
require("./checkbox.types");
const CheckSmall = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@pulse-web-ui/icons/lib/lazy/rgs-check'))));
exports.StyledCheckboxTooltip = theme_1.styled.div `
  padding: 24px 0;
`;
exports.NativeCheckbox = theme_1.styled.input `
  display: none;
`;
exports.IconCheck = (0, theme_1.styled)(CheckSmall) ``;
exports.Checkbox = theme_1.styled.label `
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  outline: none;
  flex-shrink: 0;

  ${exports.NativeCheckbox}:disabled + & {
    cursor: not-allowed;
    border-color: ${({ theme }) => theme.colors.neutral[30]};
    background-color: ${({ theme }) => theme.colors.neutral[30]};
    color: ${({ theme }) => theme.colors.text.secondary};

    ${exports.IconCheck} {
      color: ${({ theme }) => theme.colors.neutral['50']};
    }
  }

  // on
  ${exports.NativeCheckbox}:checked + & {
    border-color: ${({ theme }) => theme.colors.accent.action.normal};
    background-color: ${({ theme }) => {
    var _a;
    return ((_a = theme.common) === null || _a === void 0 ? void 0 : _a.outlined)
        ? 'transparent'
        : theme.colors.accent.action.normal;
}};
    color: ${({ theme }) => theme.colors['on-accent'].primary};

    ${exports.IconCheck} {
      display: block;
      opacity: 1;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  ${exports.NativeCheckbox}:checked:disabled + & {
    &,
    &:hover,
    &:active {
      background-color: ${({ theme }) => theme.colors.neutral[30]};
      border-color: ${({ theme }) => theme.colors.neutral[30]};
    }
  }

  ${({ variant, theme }) => variant === 'default' &&
    (0, theme_1.css) `
      width: 24px;
      height: 24px;
      border-radius: ${theme.common.radius};
      background-color: ${theme.colors.neutral[0]};
      border: 2px solid ${theme.colors.neutral[50]};
      color: ${({ theme }) => theme.colors['on-accent'].primary};
      cursor: pointer;
      user-select: none;

      ${exports.IconCheck} {
        opacity: 0;
        pointer-events: none;
      }
    `}

  ${({ status, theme }) => {
    switch (status) {
        case 'error':
            return (0, theme_1.css) `
          border-color: ${theme.colors.accent.error.normal};
          &:active {
            border-color: ${theme.colors.accent.error.normal};
          }
        `;
        case 'warning':
            return (0, theme_1.css) `
          &:hover {
            border-color: ${theme.colors.accent.action.normal};
          }
        `;
        default:
            return (0, theme_1.css) `
          &:hover {
            border-color: ${theme.colors.accent.action.normal};
          }
        `;
    }
}}
`;
exports.Wrapper = theme_1.styled.div ``;
exports.ControlWrapper = theme_1.styled.div `
  position: relative;
  display: flex;
`;
exports.Label = theme_1.styled.label `
  ${theme_1.typography.regular16};
  margin-left: 32px; // 24px checkbox with + 12px margin
  line-height: 24px;
  user-select: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.primary};
  ${exports.NativeCheckbox}:disabled ~& {
    color: ${({ theme }) => theme.colors.text.secondary};
  }
  a {
    color: ${({ theme }) => {
    var _a, _b;
    return ((_b = (_a = theme.common) === null || _a === void 0 ? void 0 : _a.a) === null || _b === void 0 ? void 0 : _b.color)
        ? theme.common.a.color
        : theme.colors.text.secondary;
}};
    text-decoration: ${({ theme }) => { var _a, _b; return ((_b = (_a = theme.common) === null || _a === void 0 ? void 0 : _a.a) === null || _b === void 0 ? void 0 : _b.decoration) ? theme.common.a.decoration : 'underline'; }};
    text-underline-offset: 0.2em;
  }
`;
exports.StyledMessage = theme_1.styled.div `
  ${theme_1.typography.regular14};
  margin-left: 32px;
  margin-top: 4px;
  color: ${({ status, theme }) => {
    switch (status) {
        case 'error':
            return theme.colors.text.error;
        case 'warning':
            return theme.colors.text.warning;
        default:
            return theme.colors.text.primary;
    }
}};
`;
exports.StyledTooltip = (0, theme_1.styled)(tooltip_1.Tooltip) `
  margin-left: 4px;
`;
